import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/landing-facebook.svg'
import _imports_1 from '@/assets/icons/landing-in.svg'


const _hoisted_1 = {
  key: 0,
  class: "banner-backdrop"
}
const _hoisted_2 = { class: "banner-container" }
const _hoisted_3 = { class: "banner" }
const _hoisted_4 = { class: "banner--title" }
const _hoisted_5 = { class: "banner--text" }
const _hoisted_6 = { class: "footer-container" }
const _hoisted_7 = { class: "info-container" }
const _hoisted_8 = { class: "after-logo" }
const _hoisted_9 = { class: "privacy-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["footer-wr", { 'with-banner': $setup.props.showBanner }])
  }, [
    ($setup.props.showBanner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString($props.isPlansView ? "Got questions?" : "Partner with us"), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString($props.isPlansView ? "Talk with sales" : "Boost your land sales projects"), 1),
              ($props.isPlansView)
                ? (_openBlock(), _createBlock($setup["ContactUsLink"], {
                    key: 0,
                    "data-aos": "fade-down",
                    text: 'Book a call',
                    toContactUsForm: false,
                    isButtonCallBackModal: true,
                    linkCalendly: $setup.CALENDLY_DEMO_LINK
                  }, null, 8, ["linkCalendly"]))
                : (_openBlock(), _createBlock($setup["ContactUsLink"], {
                    key: 1,
                    animationName: '',
                    text: $setup.bannerButtonText
                  }, null, 8, ["text"]))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.props.showContactUsForm)
      ? (_openBlock(), _createBlock($setup["ContactUsForm"], { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "logo-white" }, null, -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "location" }, "Level 2/11 York St, Sydney NSW 2000", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "divider" }, "|", -1)),
              _createVNode(_component_router_link, {
                class: "link",
                to: { name: 'Terms' },
                target: "_blank"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Terms & Conditions", -1)
                ]))]),
                _: 1
              }),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "divider" }, "|", -1)),
              _createVNode(_component_router_link, {
                class: "link",
                to: { name: 'PrivacyPolicy' },
                target: "_blank"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Privacy Policy", -1)
                ]))]),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createStaticVNode("<p class=\"divider\" data-v-1c63a620>|</p><div class=\"social\" data-v-1c63a620><a class=\"link-img\" href=\"https://www.facebook.com/lottrackr\" target=\"_blank\" data-v-1c63a620><img src=\"" + _imports_0 + "\" data-v-1c63a620></a><a class=\"link-img\" href=\"https://www.linkedin.com/company/lottrackr/\" target=\"_blank\" data-v-1c63a620><img src=\"" + _imports_1 + "\" data-v-1c63a620></a></div>", 2))
            ])
          ])
        ])
      ])
    ])
  ], 2))
}